@if (vm.loading) {
  <app-skeleton-loader class="dark w-200 h-40 sm-h-32" />
  <app-skeleton-loader class="dark full-width h-28 sm-h-24 mt-16" />
} @else {
  <button (click)="open.set(!open())">
    <i class="fa-regular fa-bolt"></i>
    <h2 class="heading-4">Electrical Risks</h2>

    <i class="fa-light fa-lg" [class.fa-chevron-up]="vm.open" [class.fa-chevron-down]="!vm.open"></i>
  </button>
  <p class="body mt-16">If your product isn’t working normally, please follow this safety advice.</p>

  <section [appAnimateOpen]="vm.open" class="content">
    <section class="flex-col gap-8 mb-4 full-width">
      <ul>
        <li>
          <p class="body">Turn it off and unplug it from the mains, if you can safely</p>
        </li>
        <li>
          <p class="body">Or, in your fuse box, turn off the circuit breaker for the room where the appliance is</p>
        </li>
      </ul>

      <p class="body">
        For more advice, visit
        <a
          href="https://www.electricalsafetyfirst.org.uk/"
          target="_blank"
          [tabIndex]="vm.open ? 0 : -1"
          class="link-text"
          >Electrical Safety First</a
        >.
      </p>
    </section>
  </section>
}
